export const newEvent = ({ event, bubbles = true, cancelable = true, }) => {
    if (typeof window.Event === "function")
        return new window.Event(event, { bubbles, cancelable });
    const e = document.createEvent("Event");
    e.initEvent(event, bubbles, cancelable);
    return e;
};
export const trigger = (e, event) => e.dispatchEvent(newEvent({ event }));
